import { makeStyles } from "@material-ui/styles";
import Leaf from "../../images/bgleaf.png";

const styles = makeStyles((theme) => ({
    mainslider: {
		float: "right",
		right: 0,
		width: "87%",
		transition: ".3s",
		"& .responsiveLogo": {
			textAlign: "center",
			position: "absolute",
			zIndex: 1,
			left: 0,
			right: 0,
			top: -50,
			width: 80,
			background: "#000",
			margin: "auto",
			"& img": {
				width: "auto"
			},
			[theme.breakpoints.down("xl")]: {
				display: "none"
			},
			[theme.breakpoints.down("sm")]: {
				display: "block"
			}
		},
		"& img": {
			minHeight: "680px",
			[theme.breakpoints.down("sm")]: {
				height: "auto",
				minHeight: 0,
			},
			[theme.breakpoints.down("xs")]: {
				height: "auto",
				minHeight: 0,
			}
		},
		[theme.breakpoints.down("md")]: {
			width: "80%"
		},
		[theme.breakpoints.down("sm")]: {
			width: "100%"
		}
	},
	Wrapper: {
		position: "relative"
	},
	banner: {
		width: "90%",
		margin: "auto",
		maxWidth: 1700,
		transition: "all ease .5s",
		height: 400,
		backgroundSize: "cover",
		marginTop: 20,
		marginBottom: 50,
		[theme.breakpoints.down("sm")]: {
			marginBottom: 20,
			height: 150
		}
	},
	logo: {
		position: "absolute",
		width: 100,
		left: 0,
		right: 0,
		margin: "auto",
		marginTop: -100,
		[theme.breakpoints.down("lg")]: {
			marginTop: -91,
		},
		[theme.breakpoints.down("xl")]: {
			marginTop: -91,
		},
		[theme.breakpoints.down("sm")]: {
			background: "black",
			marginTop: -50,
			width: 80
		}
	},
	enquire: {
		position: "fixed",
		right: 0,
		writingMode: "vertical-rl",
		textOrientation: "upright",
		background: "#bd9a5c",
		color: "#fff",
		padding: "10px 0",
		fontSize: 14,
		textTransform: "uppercase",
		cursor: "pointer",
		top: "40%",
		minWidth: 30,
		zIndex: 1,
		"&:hover": {
			background: "#a5731c"
		},
		"& span": {
			writingMode: "vertical-rl",
			textOrientation: "upright",
			textTransform: "uppercase",
			minWidth: 30,
			width: 30
		}
	},
	dialogBg: {
		background: "#bd9a5c",
		paddingBottom: 20
	},
	crumps: {
		zIndex: 1
	},
    leafwrapper: {
		backgroundImage: `url(${Leaf})`,
		width: 250,
		height: 300,
		backgroundSize: "cover",
		display: "block",
		position: "absolute",
		bottom: -150,
		left: -20,
		zIndex: -1,
		[theme.breakpoints.down("sm")]: {
			display: "none"
		}
	},
	bannerBlock: {
		position: 'relative',
		textAlign: 'center'
	},
	bannerText: {
		position: 'absolute',
		top: "50%",
		left: "50%",
		transform: 'translate(-50%, -50%)',
		border: '3px solid #fff',
		color: '#fff',
		padding: '15px 25px',
		fontSize: 30,
		fontWeight: 'bold',
		[theme.breakpoints.down("sm")]: {
			padding: '5px 10px',
			fontSize: 12,
		}
	},
	bannerText1: {
		position: 'absolute',
		top: "50%",
		left: "50%",
		transform: 'translate(-50%, 150%)',
		border: '3px solid #fff',
		color: '#fff',
		padding: '15px 25px',
		fontSize: 30,
		fontWeight: 'bold',
		[theme.breakpoints.down("sm")]: {
			padding: '5px 10px',
			fontSize: 12,
		}
	}
}));
export default styles;
